function htRem() {
  var ww = document.documentElement.clientWidth;
  if (ww > 1920) {
      ww = 1920;
  }
  document.documentElement.style.fontSize = ww / 19.2 + "px";
}
htRem();
window.onresize = function() {
  htRem();
};